import { GroupByPipe } from './pipes/group-by-pipe';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ChartsModule, StockChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { UploadModule } from '@progress/kendo-angular-upload';
import { declarations } from './shared.index';
import { RemoveCommaPipe } from './pipes/removeComma';
import { DateFormatPipe } from './pipes/dateFormat';
import { CostFormatPipe } from './pipes/costFormat';
import { DialogLayoutComponent } from './components/dialog-layout/dialog-layout.component';
import { LayoutManagerService, PORTAL_DATA } from './components/layout/layout-manager';
import { EditFormsComponent } from './components/forms/edit-forms/edit-forms.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MulticheckFilterComponent } from './components/grid/layout/multicheck-filter/multicheck-filter.component';
import { EditColumnsComponent } from './components/grid/layout/edit-columns/edit-columns.component';
import { ReactivateDataComponent } from './components/reactivate-data/reactivate-data.component';
import { PasswordStrengthComponent } from './components/password-strength/password-strength/password-strength.component';
import { ComplexFieldValuePipe } from './pipes/complex-field-value.pipe';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { PopupSelectorComponent } from './components/PopupSelectors/popup-selector.component';
import { BarcodePrintComponent } from './components/barcode/barcode-print/barcode-print.component';
import { QuantityFormatPipe } from './pipes/quantity-format.pipe';
import { TransactionsFieldsEditorComponent } from './components/transactionFields/transactions-fields-editor.component';
import { ImagePopupDirective } from './directives/image-popup/image-popup.directive';
import { GridNotesComponent } from './components/gridNotes/grid-notes.component';
import { CacheResolverService } from '~/services/modules/common/Caching/cacheResolverService';
import { CacheInterceptor } from '~/services/modules/common/Caching/cacheInterceptor';
import { AllSitesDropdownComponent } from './components/all-sites-dropdown/all-sites-dropdown.component';
import { AccountsDropdownComponent } from './components/accounts-dropdown/accounts-dropdown.component';
import { SitesDropdownComponent } from './components/sites-dropdown/sites-dropdown.component';
import { VersionComponent } from './components/version/version.component';
import { UnlicensedComponent } from './components/unlicensed/unlicensed.component';
import { DocumentsGridComponent } from './components/documents-grid/documents-grid.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { IconsModule, ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { NavigationModule } from "@progress/kendo-angular-navigation";
import { PopupModule } from "@progress/kendo-angular-popup";
import { MaintenanceAlertComponent } from './components/maintenance-alert/maintenance-alert.component';
import { SnapshotWidgetComponent } from './components/snapshot-widget/snapshot-widget.component';
import { DebounceFilterDirective } from './directives/debounce-filter/debounce-filter.directive';
import { MultiSelectDropdownDirective } from './directives/multiselect/multiselect-dropdown.directive';
import { DocumentManagerComponent } from './components/document-manager/document-manager.component';
import { SelectedAssetGridComponent } from './components/selected-asset-grid';
import { AccountSitesSelectionComponent } from './components/account-sites-selection';

//  import { BarcodesModule } from '@progress/kendo-angular-barcodes';
@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PortalModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressBarModule,
    GridModule,
    GaugesModule,
    LabelModule,
    ChartsModule,
    ButtonsModule,
    InputsModule,
    LayoutModule,
    DialogModule,
    UploadModule,
    WindowModule,
    DropDownsModule,
    ToolBarModule,
    DateInputsModule,
    ExcelModule,
    PDFModule,
    IndicatorsModule,
    SortableModule,
    StockChartModule,
    HttpClientJsonpModule,
    NgApexchartsModule,
    ContextMenuModule,
    CommonModule,
    RouterModule,
    // BarcodesModule,
    IconsModule,
    NavigationModule,
    PopupModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PortalModule,
    OverlayModule,
    declarations,
    ProgressBarModule,
    GridModule,
    ExcelModule,
    PDFModule,
    GaugesModule,
    LabelModule,
    ChartsModule,
    ButtonsModule,
    InputsModule,
    LayoutModule,
    DialogModule,
    UploadModule,
    WindowModule,
    DropDownsModule,
    ToolBarModule,
    DateInputsModule,
    ExcelModule,
    IndicatorsModule,
    SortableModule,
    RemoveCommaPipe,
    DateFormatPipe,
    CostFormatPipe,
    QuantityFormatPipe,
    DialogLayoutComponent,
    EditFormsComponent,
    NgApexchartsModule,
    ContextMenuModule,
    PasswordStrengthComponent,
    ComplexFieldValuePipe,
    FormFieldComponent,
    PopupSelectorComponent,
    ComplexFieldValuePipe,
    FormFieldComponent,
    BarcodePrintComponent,
    TransactionsFieldsEditorComponent,
    DebounceFilterDirective,
    MultiSelectDropdownDirective,
    AllSitesDropdownComponent,
    AccountsDropdownComponent,
    SitesDropdownComponent,
    DocumentsGridComponent,
    MaintenanceAlertComponent,
    CommonModule,
    IconsModule,
    NavigationModule,
    PopupModule,
    SnapshotWidgetComponent,
    DocumentManagerComponent,
    SelectedAssetGridComponent,
    AccountSitesSelectionComponent,
  ],
  declarations: [declarations,
    RemoveCommaPipe,
    DateFormatPipe,
    CostFormatPipe,
    DialogLayoutComponent,
    EditFormsComponent,
    MulticheckFilterComponent,
    EditColumnsComponent,
    ReactivateDataComponent,
    GroupByPipe,
    PasswordStrengthComponent,
    ComplexFieldValuePipe,
    FormFieldComponent,
    PopupSelectorComponent,
    QuantityFormatPipe,
    BarcodePrintComponent,
    TransactionsFieldsEditorComponent,
    ImagePopupDirective,
    DebounceFilterDirective,
    GridNotesComponent,
    AllSitesDropdownComponent,
    AccountsDropdownComponent,
    SitesDropdownComponent,
    VersionComponent,
    UnlicensedComponent,
    DocumentsGridComponent,
    HighlightPipe,
    MaintenanceAlertComponent,
    SnapshotWidgetComponent,
    DocumentManagerComponent,
    SelectedAssetGridComponent,
  ],
  providers: [
    LayoutManagerService,
    DateFormatPipe,
    ComplexFieldValuePipe,
    CostFormatPipe,
    CacheResolverService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    { provide: PORTAL_DATA, useValue: {} }],
})
export class SharedModule { }
